import { Box, BoxProps } from '@chakra-ui/react';
import { mergeWith } from '@chakra-ui/utils';
import PropTypes from 'prop-types';
import React from 'react';

import { useMultiStyleConfig } from '../../system/hooks';

import DisplayNames from './enums';

export type ResponsiveTwoColumnLayoutProps = BoxProps;

const ResponsiveTwoColumnLayout = (props: ResponsiveTwoColumnLayoutProps): React.ReactElement => {
  const { __css, children, ...rest } = props;
  const { responsiveTwoColumnLayout: style } = useMultiStyleConfig('ResponsiveLayoutTheme', props);
  return (
    <Box __css={mergeWith(style, __css)} {...rest}>
      {children}
    </Box>
  );
};

ResponsiveTwoColumnLayout.propTypes = {
  children: PropTypes.node.isRequired
};
ResponsiveTwoColumnLayout.displayName = DisplayNames.ResponsiveTwoColumnLayout;

export default ResponsiveTwoColumnLayout;
